import React from "react";
import { motion } from "framer-motion";
import { AiOutlineClose } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";

const StatusChangeModal = ({
    showStatusModal,
    setShowStatusModal,
    selectedStatus,
    setSelectedStatus,
    handleChangeStatus,
    statusFlow = ["Received", "Confirmed", "Shipped", "Out For Delivery", "Delivered", "Cancelled"],
}) => {
    if (!showStatusModal) return null;
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 flex items-end justify-center bg-black bg-opacity-50 z-50"
            onClick={() => setShowStatusModal(false)}
        >
            <motion.div
                initial={{ y: "100vh", opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: "100vh", opacity: 0 }}
                transition={{
                    type: "spring",
                    stiffness: 70,
                    damping: 15,
                }}
                className="bg-white mb-[-1px] md:mb-[73px] rounded-lg rounded-bl-none rounded-br-none shadow-lg w-full md:w-[50%] md:max-h-[100vh] max-h-[58vh] p-6 overflow-y-auto transform no-scrollbar"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold text-gray-800">Change Status</h2>
                    <motion.div
                        onClick={() => setShowStatusModal(false)}
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        className="cursor-pointer text-gray-500"
                    >
                        <AiOutlineClose className="w-5 h-5" />
                    </motion.div>
                </div>

                {/* Status Options */}
                <div className="space-y-4">
                    {statusFlow.map((status) => (
                        <div
                            key={status}
                            className={`flex items-center justify-between p-2 px-3 border rounded-lg cursor-pointer ${
                                selectedStatus === status
                                    ? "bg-green-100 border-green-300"
                                    : "bg-gray-50 hover:bg-gray-100"
                            }`}
                            onClick={() => setSelectedStatus(status)}
                        >
                            <span
                                className={`text-[16px] font-semibold ${
                                    selectedStatus === status
                                        ? "text-green-600"
                                        : "text-gray-800"
                                }`}
                            >
                                {status}
                            </span>
                            {selectedStatus === status && (
                                <FaCheck className="w-4 h-4 text-green-600" />
                            )}
                        </div>
                    ))}
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between mt-6 gap-4">
                    <button
                        className="px-3 py-2 text-lg font-semibold text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition w-full"
                        onClick={() => setShowStatusModal(false)}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-3 py-2 text-lg font-semibold text-white bg-green-600 rounded-lg hover:bg-green-700 transition w-full"
                        onClick={() => handleChangeStatus(selectedStatus)}
                    >
                        Save
                    </button>
                </div>
            </motion.div>
        </motion.div>
    );
};
export default StatusChangeModal;